import Vue from 'vue'

const selectLabelFun = (value, ...args) => {
  const [list, key, label] = args
  const found = list.find(item => item[key] === value)
  if (found !== undefined) {

  } else {

  }
  return found !== undefined ? found[label] : value
}
Vue.filter('select', selectLabelFun)

export const operateName = (operate = '0', otherInfo = '') => {
  switch (operate) {
    case '2':
      return otherInfo + '详情'
    case '1':
      return '修改' + otherInfo
    case '0':
    default:
      return '新增' + otherInfo
  }
}

export const timePipe = (timeStr = '') => {
  if (timeStr && timeStr.length >= 14) {
    const year = timeStr.slice(0, 4)
    const month = timeStr.slice(4, 6)
    const day = timeStr.slice(6, 8)
    const hour = timeStr.slice(8, 10)
    const min = timeStr.slice(10, 12)
    const sec = timeStr.slice(12, 14)
    const millsSec = timeStr.slice(14, 17)
    return `${year}-${month}-${day} ${hour}${min && ':' + min}${sec && ':' + sec} ${millsSec}`.trim()
  } else if (timeStr.length === 8) {
    const year = timeStr.slice(0, 4)
    const month = timeStr.slice(4, 6)
    const day = timeStr.slice(6, 8)
    return `${year}-${month}-${day}`.trim()
  } else {
    return timeStr
  }
}
Vue.filter('timePipe', timePipe)

// 格式化合计的金额
export const amountPipe = (amount = '') => {
  return amount
    .toFixed(2)
    .toString()
    .split('')
    .reverse()
    .join('')
    /* .replace(/(\d{3}\B)/g, '$1,') 为了保持报表金额格式统一，先不加逗号 */
    .split('')
    .reverse()
    .join('')
}
Vue.filter('amountPipe', amountPipe)

// 指定列求和(通用)
export const getSummaries = (param, calcFlag = false) => {
  const {columns, data} = param
  const sums = []
  columns.forEach((column, index) => {
    if (index === 0) {
      sums[index] = '合计'
      return
    }
    // 自定义其他列都不显示（默认是显示0）
    sums[index] = ''
    if (column.property !== undefined) {
      if (isAmount(column.property) || isNumber(calcFlag, column.property)) {
        const values = data.map(item => Number(item[column.property]))
        sums[index] = values.reduce((prev, curr) => {
          const value = Number(curr)
          if (!isNaN(value)) {
            return prev + curr
          } else {
            return prev
          }
        }, 0)
        // 格式化合计栏中的金额
        if (isAmount(column.property) || isNumberFormat(calcFlag, column.property)) {
          sums[index] = amountPipe(sums[index])// !!重点 要对结果进行转换
        }
      }
    }
  })
  return sums
}

// 判断是否是金额字段
export const isAmount = (columnName) => {
  if (columnName === 'amount' || columnName === 'expenditure' || columnName === 'income' || columnName.endsWith('Amount') || columnName.endsWith('Amt')) {
    return true
  }
  return false
}

// 判断是否是数字字段
export const isNumber = (calcFlag, columnName) => {
  if (calcFlag && (columnName === 'count' || columnName.endsWith('Count') || columnName.endsWith('Quantity'))) {
    return true
  }
  return false
}

// 判断是否是数字字段并格式化
export const isNumberFormat = (calcFlag, columnName) => {
  if (calcFlag && (columnName.endsWith('Quantity'))) {
    return true
  }
  return false
}

// 金额格式化为大写
export const convertAmountPipe = (number) => {
  const fraction = ['角', '分']
  const digit = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖']
  const unit = [['元', '万', '亿'], ['', '拾', '佰', '仟']]
  let num = Math.abs(number)
  let s = ''
  for (let i = 0; i < fraction.length; i++) {
    s += (
      digit[Math.floor(num * 10 * Math.pow(10, i)) % 10] +
      fraction[i]
    ).replace(/零./, '')
  }
  s = s || '整'
  num = Math.floor(num)
  for (let i = 0; i < unit[0].length && num > 0; i++) {
    let p = ''
    for (let j = 0; j < unit[1].length && num > 0; j++) {
      p = digit[num % 10] + unit[1][j] + p
      num = Math.floor(num / 10)
    }
    s = p.replace(/(零.)*零$/, '').replace(/^$/, '零') + unit[0][i] + s
  }
  return s
}
Vue.filter('convertAmountPipe', convertAmountPipe)

// 格式化日期
export const dateFormat = (date) => {
  if (date) {
    if (date.length === 8) {
      return date.substring(0, 4) + '-' + date.substring(4, 6) + '-' + date.substring(6, 8)
    } else if (date.length === 14) {
      return date.substring(0, 4) + '-' + date.substring(4, 6) + '-' + date.substring(6, 8) + ' ' + date.substring(8, 10) + ':' + date.substring(10, 12) + ':' + date.substring(12, 14)
    } else {
      return ''
    }
  }
}

// 指定格式显示当前日期
export const currentDateFormat = (flag) => {
  var date = new Date()
  var year = date.getFullYear()
  /* 在日期格式中，月份是从0开始的，因此要加0
  * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
  * */
  var month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
  var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
  var hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
  var minutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
  var seconds = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
  // 拼接
  let timestamp = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
  if (flag === 'none') {
    timestamp = timestamp.replaceAll('-', '').replaceAll(' ', '').replaceAll(':', '')
  }
  return timestamp
}

// 获取el-table中el-table-column的label
export const getColumnLabels = (columns) => {
  return columns.map(column => column.label)
}

// 获取el-table中el-table-column的prop
export const getColumnProps = (columns) => {
  return columns.map(column => column.property)
}

/**
 *  格式数据
 *  @filterVal  格式头
 *  @tableData  用来格式的表格数据
 */
export const formatJson = (filterVal, jsonData) => {
  return jsonData.map(v => filterVal.map(j => {
    if (j === 'tranDt') {
      if (v['tranTm']) {
        return timePipe(v[j] + v['tranTm'])
      } else {
        return timePipe(v[j])
      }
    } else if (j === 'calAmount') {
      return (v['quantity'] * v['sellingPrice']).toFixed(2)
    } else if (j.endsWith('Date') || j.endsWith('Time')) {
      return timePipe(v[j])
    } else if (j.endsWith('Flag')) {
      return v[j] === '1' ? '是' : '否'
    } else {
      return v[j] === undefined ? '' : v[j]
    }
  }))
}

/**
 * excel设置表格样式
 * @returns {string[]}
 */
export const arrabc = (index) => {
  var arrabc = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']
  return arrabc[index]
}



// WEBPACK FOOTER //
// ./src/util/erp_handle.js